import { LatLng } from "use-places-autocomplete";
import {
  calculateDistanceBetweenTwoCoordinates,
  sortFranchise,
} from "../../../utils/help/location/locationHelp";
import { Restaurant } from "../../../utils/types";
import { InitialState } from "../slices/configSlice";

export const handleSelectPartnerRestaurant = (
  state: InitialState,
  newPartnerRestaurantId: number,
  restaurant: Restaurant,
  refreshRestaurantData: boolean = false
) => {
  const newRestaurnatIndex = (
    refreshRestaurantData ? restaurant : state
  ).partnerRestaurants.findIndex(
    (res: Restaurant) => res.id === newPartnerRestaurantId
  );

  if (newRestaurnatIndex > -1) {
    const newPartners = [...state.partnerRestaurants];
    const newRestaurnat = {
      ...newPartners.splice(newRestaurnatIndex, 1)[0],
    };
    newRestaurnat.franchises = restaurant!.franchises;
    newPartners.push(restaurant!);
    setAllRestaurantDetails(state, newRestaurnat, newPartners);
  } else {
    setAllRestaurantDetails(state, restaurant, restaurant.partnerRestaurants);
  }

  // Set flags to indicate cart should be cleared and restaurant switch is in progress
  state.shouldClearCartDueToRestaurantSwitch = true;
  state.isRestaurantSwitchInProgress = true;
};

export const handleSortActiveFranchises = (
  state: InitialState,
  payload: LatLng
) => {
  for (let index = 0; index < state.activeFranchises.length; index++) {
    let currentFranchiseLocation: LatLng | undefined;

    if (
      state.activeFranchises[index]?.location &&
      state.activeFranchises[index].location?.lat &&
      state.activeFranchises[index].location?.lng
    ) {
      currentFranchiseLocation = state.activeFranchises[index].location;
    }

    // Read the coordinates out rather than cloning: `state` is an immer draft,
    // so `currentFranchiseLocation` is a draft Proxy and lodash.clonedeep walks
    // its `constructor.prototype`, which violates a Proxy invariant and throws
    // (PREPITS-GUEST-3RT). Primitives are all the distance helper needs.
    const distanceFromLocationInMeters = currentFranchiseLocation
      ? calculateDistanceBetweenTwoCoordinates(payload, {
          lat: currentFranchiseLocation.lat,
          lng: currentFranchiseLocation.lng,
        })
      : undefined;
    state.activeFranchises[index].distanceFromLocationInMeters =
      distanceFromLocationInMeters;
  }
  state.activeFranchises = state.activeFranchises.sort((a, b) =>
    sortFranchise(a, b)
  );
};

export const setAllRestaurantDetails = (
  state: InitialState,
  restaurant: Restaurant,
  partnerRestaurants: Restaurant[]
) => {
  state.partnerRestaurants = partnerRestaurants;
  state.restaurantInfo = restaurant;
  state.restaurantConfig = restaurant.config;
  const activeFranchises = (restaurant?.franchises || []).filter(
    (f) => f.live && !f.franchiseConfig?.catering
  );
  state.activeFranchises = activeFranchises;
  if (state.selectedFranchise) {
    const currentFranchise = activeFranchises.find(
      (af) => af.id === state.selectedFranchise?.id
    );

    // Only reassign when the franchise actually differs. The point of
    // reassigning is to pick up a changed franchiseConfig, and replacing an
    // identical object achieves nothing except a new identity -- which IS a
    // change to anything watching it. SelfServiceScreen keys an effect on
    // `selectedFranchise` and resets the cart from it, so a page load that
    // merely re-derived the same franchise reset the cart and re-rendered the
    // screen out from under itself. Harmless before #4204, when this ran once
    // per browser fetch; not harmless now that the config is hydrated from the
    // page on every load.
    //
    // Compared with JSON.stringify, NOT lodash.clonedeep: `state` is an immer
    // draft and clonedeep walks `constructor.prototype`, which violates a Proxy
    // invariant and throws (PREPITS-GUEST-3RT). stringify only reads own
    // enumerable properties, which the draft serves fine.
    if (
      currentFranchise &&
      JSON.stringify(currentFranchise) !==
        JSON.stringify(state.selectedFranchise)
    ) {
      state.selectedFranchise = currentFranchise;
    }
  }
};
